import { render, staticRenderFns } from "./phoneField.vue?vue&type=template&id=3af735bb&scoped=true"
import script from "./phoneField.vue?vue&type=script&lang=js"
export * from "./phoneField.vue?vue&type=script&lang=js"
import style0 from "./phoneField.vue?vue&type=style&index=0&id=3af735bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af735bb",
  null
  
)

export default component.exports